





































import { computed, defineComponent } from '@nuxtjs/composition-api';
import { useUser } from '~/modules/customer/composables/useUser';

export default defineComponent({
  name: 'CaregiverProfile',
  components: {},
  setup() {
    const { user } = useUser();

    const caregiver = computed(() => user.value.approved_by?.[0]);

    return {
      caregiver,
    };
  },
});
